<template>
  <el-dialog
    :title="editId?'编辑绑定':'新增绑定'"
    :visible.sync="addDialogVisible"
    width="40%"
    center
    :close-on-click-modal="false"
    @close="dialogCloseFun"
  >
    <el-form
      ref="ruleForm"
      :model="trainForm"
      label-width="160px"
      :rules="rules"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="clintID："
            prop="bimClientId"
          >
            <el-input v-model="trainForm.bimClientId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="clintsecret："
            prop="bimClientSecret"
          >
            <el-input v-model="trainForm.bimClientSecret"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { Api_setting } from '@/api/api'

export default {
  data() {
    return {
      addDialogVisible: false,
      editId: 0,
      trainForm: {
        bimClientId: '',
        bimClientSecret: ''
      },
      rules: {
        bimClientId: [{
          required: true,
          message: "请输入bimClientId",
          trigger: "blur",
        }],
        bimClientSecret: [{
          required: true,
          message: "请输入bimClientSecret",
          trigger: "blur",
        }],
      },
    }
  },
  methods: {
    open(val) {
      this.addDialogVisible = true
      if (val) { // 编辑绑定
        this.trainForm = val
      } else {
        this.trainForm = {}
        this.editId = 0;
      }
    },
    dialogCloseFun() {
      this.resetForm('ruleForm')
      this.addDialogVisible = false
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addDialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveConfigFunc()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async saveConfigFunc() {
      const params = {
        ...this.trainForm
      }
      const { data: { statusCode, errors } } = await Api_setting.savePkAccount(params)
      if (statusCode === 200) {
        this.addDialogVisible = false
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.$emit('updateList')
      } else {
        this.$showMessage("失败", errors);
      }
    },
  },
}
</script>
